import { RULES } from './rules';
/** Monotonic, fixed-step clock. No gameplay timers exist outside this clock. */
export class TickClock {
 accumulator=0; last=0; ticks=0; running=false; origin=0;
 constructor(private step:()=>void,private invalid:(reason:string)=>void,private realtime=true){}
 start(now:number){this.accumulator=0;this.last=now;this.origin=now;this.ticks=0;this.running=true;}
 stop(){this.running=false;}
 advance(now:number):number{
  if(!this.running)return 0;
  const elapsed=now-this.last;
  if(elapsed<0 || (this.realtime&&elapsed>RULES.stallLimitMs)){this.running=false;this.invalid('Presentation stalled; this attempt is invalid.');return 0;}
  this.last=now;this.accumulator+=elapsed;
  while(this.accumulator+1e-7>=RULES.tickMs&&this.running){this.accumulator=Math.max(0,this.accumulator-RULES.tickMs);this.ticks++;this.step();}
  return this.accumulator/RULES.tickMs;
 }
 inputTick(timestamp:number){return Math.max(this.ticks+1,Math.floor((timestamp-this.origin)/RULES.tickMs)+1);}
 get virtualMs(){return this.ticks*RULES.tickMs;}
}
